if (!customElements.get('sdc-cart-delivery')) {
  customElements.define('sdc-cart-delivery', class extends HTMLElement {
    connectedCallback() {
      this.update();
      this.interval = setInterval(() => this.update(), 60000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const uk = this.dataset.country === 'GB';
      const locale = this.dataset.locale || 'it';
      const bits = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {timeZone:uk?'Europe/London':'Europe/Rome',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',hourCycle:'h23'}).formatToParts(new Date()).map(part => [part.type,part.value]));
      const ranges = [...new Set(this.dataset.kinds.split(',').filter(Boolean))].map(() => [5,8]);
      if (!ranges.length) { this.hidden = true; return; }
      const base = new Date(Date.UTC(+bits.year,+bits.month-1,+bits.day,12));
      const date = days => { const value = new Date(base); value.setUTCDate(value.getUTCDate()+days); return value; };
      const from = date(Math.min(...ranges.map(range => range[0])));
      const to = date(Math.max(...ranges.map(range => range[1])));
      const format = new Intl.DateTimeFormat(uk && locale === 'en'?'en-GB':locale,{day:'numeric',month:'long',timeZone:'UTC'});
      const sharkOnly = this.dataset.kinds.split(',').filter(Boolean).every(kind => kind === 'shark');
      this.querySelector('[data-cart-delivery-range]').textContent = !sharkOnly && from.getUTCMonth() === to.getUTCMonth() ? `${from.getUTCDate()}–${to.getUTCDate()} ${new Intl.DateTimeFormat(locale,{month:'long',timeZone:'UTC'}).format(to)}` : `${format.format(from)} – ${format.format(to)}`;
    }
  });
}
